import { PAYMENTMETHOD } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const PaymentMethod = (payload) => {
  return apiInstance.post(PAYMENTMETHOD, payload);
};
